import { ViewFactory } from 'wdc-cube-react'
import UserManagerFormScope from '../um_form_scope'
import UserManagerFormView from './um_form_view'

export function registerViews(rv = ViewFactory.register) {
    rv(UserManagerFormScope, UserManagerFormView)
}
